// extracted by mini-css-extract-plugin
module.exports = {"Wrapper":"Footer_Wrapper__3lqQU","Container":"Footer_Container__NrKyv","Link":"Footer_Link__3soy8","Text":"Footer_Text__3npRi"};